import { useLenis } from "lenis/react";

export const useScrollTo = () => {
  const lenis = useLenis();
  return (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
};
